export default {"src":"/_next/static/media/rhubarb.317532b0.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};